export default function ResponseTimeChart() {
  return (
    <div
      className="bg-white rounded-[18px] border border-zinc-200 p-6 md:p-8 w-full"
      style={{
        boxShadow: '0 20px 45px -24px rgba(15,23,42,0.35)',
      }}
    >
      <h3 className="text-sm font-semibold text-zinc-900 mb-1">
        Search Efficiency
      </h3>
      <p className="text-xs text-zinc-500 mb-8">
        One query reaches every broker simultaneously
      </p>
      <div className="flex items-end gap-6 md:gap-10 h-44 md:h-48 px-2">
        <div className="flex-1 flex flex-col items-center gap-3">
          <div
            className="w-full bg-zinc-200 rounded-t-lg relative overflow-hidden"
            style={{ height: '100%' }}
          >
            <div
              className="absolute bottom-0 left-0 right-0 bg-zinc-300 rounded-t-lg animate-bar-rise"
              style={{ height: '100%', animationDelay: '0.2s' }}
            />
          </div>
          <span className="text-xs text-zinc-500 text-center leading-tight">
            4 separate
            <br />
            portal searches
          </span>
        </div>
        <div className="flex-1 flex flex-col items-center gap-3">
          <div
            className="w-full bg-blue-50 rounded-t-lg relative overflow-hidden"
            style={{ height: '28%' }}
          >
            <div
              className="absolute bottom-0 left-0 right-0 bg-blue-600 rounded-t-lg animate-bar-rise"
              style={{ height: '100%' }}
            />
          </div>
          <span className="text-xs text-blue-600 font-medium text-center leading-tight">
            1 unified
            <br />
            LoadAPI search
          </span>
        </div>
      </div>
    </div>
  );
}